import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { MARKET_EVENTS, findMarketEvents, groupEventsByYear } from '../utils/marketEvents';
import './HistoryCard.css';

const MarketEventsCoverage = ({ startDate, endDate }) => {
  return (
    <div className="market-events-coverage">
      <div className="coverage-header">
        Market Events Coverage
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id="market-events-tooltip">
              Shows significant market events that occurred during the backtest period
            </Tooltip>
          }
        >
          <span className="info-icon-wrapper">
            <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
          </span>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default MarketEventsCoverage;